<main class="contacts container">
  <div class="contacts__content">
    <h1 class="contacts__title">Contact Information & Additional Guidance</h1>

    @for (item of contactsData; track item) {
      <div class="contacts-group">
        <div class="contacts-group__header">
          <!-- Image comes first -->
          <img [attr.data-src]="item?.image" alt="Contact photo" class="contacts-group__photo" [hidden]="!item?.image">
          <h3 class="contacts-group__title">{{ item.title }}</h3>
        </div>

        @for (link of item.links; track link) {
          <a href="{{link.value}}"
             target="_blank"
             class="contacts-group__link">{{link.title || link.value}}</a>
        }

        @for (phone of item.phones; track phone) {
          <a href="tel:{{phone.value}}"
             class="contacts-group__phone">{{phone.title}}</a>
        }
      </div>
    }
  </div>
</main>
